import React from 'react';
import Title from '../../../../../@casino/ui/title';
import makeStyles from '@material-ui/core/styles/makeStyles';
import TableCasino from '../../components/table';
import Dialog from '@material-ui/core/Dialog';
import { setPostCreatePaymentSystem } from '../../store/thunk/setPostCreatePaymentSystem';
import { useDispatch, useSelector } from 'react-redux';
import { setGetListPaymentSystem } from '../../store/thunk/setGetListPaymentSystem';
import { setUpdatePaymentSystem } from '../../store/thunk/setUpdatePaymentSystem';
import PaymentItem from '../../components/payment';
import { Switch } from '@material-ui/core';
import { setGetListPaymentSystemAction } from '../../store/action';

const useStyles = makeStyles(() => ({
    wrapBlock: {
        padding: 20,
        background: '#1b2039',
        borderRadius: 8,
        marginBottom: 12
    },
    wrap: {
        background: '#1b2039',
        borderRadius: 8,
        marginBottom: 12,
        padding: 10,
    },
    search: {
        padding: 10,
        background: '#141b33',
        border: '1px solid #141b33',
        color: '#fff',
        outline: 'none',
        width: 'calc(100% - 20px)'
    }
}));

const PaymentSystemList = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [search, setSearch] = React.useState('')
    const [openModal, setOpenModal] = React.useState(false);
    const [label, setLabel] = React.useState('');
    const [status, setStatus] = React.useState(true);

    React.useEffect(() => {
        dispatch(setGetListPaymentSystem({
            search: '',
            status
        }))
    }, [])

    const list = useSelector((state) => state.payment.list);

    return (
        <div style={{ padding: 20, paddingTop: 0 }}>
            <Title
                label="Платежные системы"
                button={() => setOpenModal(true)}
                labelBtn="Добавить"
            />
            <div className={classes.wrap}>
                <input
                    type="text"
                    placeholder="Поиск"
                    className={classes.search}
                    value={search}
                    onChange={(v) => {
                        dispatch(setGetListPaymentSystem({
                            search: v.target.value,
                            status
                        }));
                        setSearch(v.target.value);
                    }}
                />
                <label htmlFor="check">
                    <span style={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        position: 'relative',
                        display: 'inline-block',
                        fontSize: '11px',
                        color: 'hsla(0,0%,100%,.7)',
                        marginBottom: '4px',
                        verticalAlign: 'middle',
                        fontFamily: "PT Sans, sans-serif",
                        userSelect: 'none'
                    }}>Включенные</span>
                    <Switch
                        checked={status}
                        onChange={() => {
                            setStatus(status => !status);
                            dispatch(setGetListPaymentSystemAction([]));
                            dispatch(setGetListPaymentSystem({
                                search,
                                status: !status
                            }));
                        }}
                        color="primary"
                        name="checkedB"
                        inputProps={{ 'aria-label': 'primary checkbox' }}
                    />
                </label>
            </div>
            <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', justifyContent: 'flex-start' }}>
                {
                    list.map((item) => (
                        <PaymentItem {...item} />
                    ))
                }
            </div>
            <Dialog onClose={() => setOpenModal(false)} open={openModal}>
                <div style={{
                    padding: 20
                }}>
                    <h3 style={{ padding: 0, margin: 0, textAlign: 'center', fontWeight: 500 }}>Добавить платежную систему</h3>
                    <div style={{ marginTop: 12 }}>
                        <label htmlFor="label" style={{}}>
                            <span>Название платежной системы</span>
                            <input
                                type="text"
                                id="label"
                                name="label"
                                value={label}
                                onChange={(v) => setLabel(v.target.value)}
                                style={{
                                    border: '1px solid #eee',
                                    width: 'calc(100% - 20px)',
                                    borderRadius: 4,
                                    outline: 'none',
                                    padding: 10,
                                }}
                            />
                        </label>
                        <div style={{ marginTop: 20, width: '100%', display: 'flex', justifyContent: 'center' }}>
                            <span
                                onClick={() => {
                                    dispatch(setPostCreatePaymentSystem({
                                        label,
                                    }))
                                    setOpenModal(false);
                                }}
                                style={{ background: 'rgb(255, 195, 36)', borderRadius: 4, padding: '10px 0', width: '100%', textAlign: 'center', cursor: 'pointer' }}>
                                Создать
                            </span>
                        </div>

                    </div>
                </div>
            </Dialog>
        </div>
    )
}

export default PaymentSystemList;